<template>  
  <section id="room-notes">
    <h1 v-if="notes.current.length > 0">Noteringar</h1>
    <ul class="notes">
    
      <li 
      v-for="(note, i) in notes.current"
      v-bind:key="i"
      >
          <p>
            <button 
            class="checkbox" 
            v-on:click="toggleDone(note)" v-bind:data-checked="note.done"
            >&nbsp;</button>
            {{ note.title }}<br>
            <span class="created-at">{{ note.created_at }}</span>
            <span class="edit-note" @click="editNote(note)"><i class="fas fa-pen"></i></span>
          </p>
      </li>
    </ul>
    <h1 v-if="notes.recent.length > 0">Tidigare noteringar</h1>
    <ul 
      class="notes"
      v-if="notes.recent.length > 0"
    >
      <li 
      v-for="(note, i) in notes.recent"
      v-bind:key="i"
      >
          <p>
            <button 
            class="checkbox" 
            v-on:click="toggleDone(note)" v-bind:data-checked="note.done"
            >&nbsp;</button>
            {{ note.title }}<br>
            <span class="created-at">{{ note.created_at }}</span>
            <span class="edit-note" @click="editNote(note)"><i class="fas fa-pen"></i></span>
          </p>
      </li>
    </ul>
  </section>
</template>
<script>
import axios from 'axios'

  export default {  
    name: 'RoomNotes',  
    components: {
    },
    props: {
      room: Object
    },
    data () { 
      return {
        notes: {
          current: [],
          recent: []
        }
      }
    },
    methods: {
      editNote(note){
        this.$parent.editNote(note);
      },
      toggleDone(note){
        this.$parent.toggleDone(note);
        this.loadNotes();
      },
      loadNotes(){
        let self = this;
        
        axios
        .get(self.$parent.api_url + "/rooms/" +  self.room.id + "/notes", {
          headers: {
            "Content-Type": "application/json",
            'Accept': 'application/json',
            Authorization: "Bearer " + self.$parent.client.token
          }
        })
        .then(response => {
          self.notes.current = response.data.active;
          self.notes.recent = response.data.recent;
        })
        .catch(function(error) {
          this.log(error);
          this.log("Something went wrong while loading notes for current room");
        });
      }
    },
    mounted: function(){
      this.loadNotes();
    },
    watch: {
      room: {
        deep: true,
        handler: function(){
          this.loadNotes();
        },
      }
    },
    computed: {
    }
  }
</script>
<style scoped>
  h1 {
    padding: 0.25em 10px;
    background: #fff;
    font-size: 1.5em;
  }
</style>
